export default __webpack_public_path__ + "static/fininscase4-e6e827515c4717f89e034919b70ebad5.png";